import classNames from 'classnames';
import flatten from 'lodash/flatten';
import Link from 'next/link';
import React, { useMemo } from 'react';

import { Avatar, Dialog, Space, Typography } from '@sravni/react-design-system';
import { useBoolean } from '@sravni/react-utils';

import {
  SravniNewsSharedEnumsOrganizationType,
  SravniNewsSharedModelsOrganizationData,
} from '../../__generated__/news/Api';
import { LIST_PARTNERS, LIST_PARTNERS_WITH_TYPE } from '../../constants/routes';
import { IPartnersInfoResult } from '../../interfaces/news';
import { createLinkProps } from '../../utils/routing';

import styles from './styles.module.scss';

interface IProps {
  partners: IPartnersInfoResult;

  className?: string;
}

const GROUP_NAME_BY_TYPE: Record<SravniNewsSharedEnumsOrganizationType, string> = {
  [SravniNewsSharedEnumsOrganizationType.Bank]: 'Банки',
  [SravniNewsSharedEnumsOrganizationType.Broker]: 'Брокеры',
  [SravniNewsSharedEnumsOrganizationType.Insurance]: 'Страховые компании',
  [SravniNewsSharedEnumsOrganizationType.Investment]: 'Инвестиции',
  [SravniNewsSharedEnumsOrganizationType.Mfo]: 'МФО',
  [SravniNewsSharedEnumsOrganizationType.Other]: 'Прочее',
  [SravniNewsSharedEnumsOrganizationType.School]: 'Школы',
  [SravniNewsSharedEnumsOrganizationType.MortgageAgent]: 'Ипотечные агенты',
  [SravniNewsSharedEnumsOrganizationType.NonbankingOrganization]: 'Не банковские организации',
};

const OrgTeg: React.FC<SravniNewsSharedModelsOrganizationData> = ({ logotype, name, type, alias }) => {
  const isOther = type === 'other';
  const linkProps = createLinkProps('list', isOther ? LIST_PARTNERS : LIST_PARTNERS_WITH_TYPE, {
    ...(!isOther && { organizationType: type === 'bank' ? 'bank' : 'strakhovaja-kompanija' }),
    organizationAlias: alias,
  });
  return (
    <Link {...linkProps}>
      <Typography.Link className={styles.link} href={linkProps.as}>
        <Avatar className={styles.logo} src={logotype} /> {name}
      </Typography.Link>
    </Link>
  );
};

export const OrgDialogSelector: React.FC<IProps> = ({ partners, className }) => {
  const [isOpened, setIsOpened] = useBoolean();
  const orgs = flatten(Object.values(partners));

  const letters = useMemo(
    () =>
      Object.entries(partners).map(([type, optionsGroup]) => (
        <Space key={type} className={styles['orgs-block']} direction="vertical">
          <Typography.Text size={16} className={styles.subtitle}>
            {GROUP_NAME_BY_TYPE[type]}
          </Typography.Text>
          {optionsGroup?.map(OrgTeg)}
        </Space>
      )),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [partners],
  );

  return (
    <>
      <Space size={0} className={classNames(styles.wrapper, className)}>
        {orgs.map(OrgTeg)}
        <Typography.Link onClick={setIsOpened.on} className={styles.button}>
          Еще
        </Typography.Link>
      </Space>
      <Dialog className={styles.dialog} visible={isOpened} onClose={setIsOpened.off}>
        <Typography.Heading className={styles.header} level={3}>
          Все компании
        </Typography.Heading>
        <div className={styles['orgs-wrapper']}>
          <div className={styles['orgs-content']}>{letters}</div>
        </div>
      </Dialog>
    </>
  );
};
